import React, { useState } from 'react';
import { Dialog, DialogContent, IconButton, DialogTitle, Grid } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { TableComponents, ExportButton, Icons } from 'components';
import { useExportFile } from 'hooks';
import { columns, columnsId } from './components/columns';
import ServiceProviderServices from '../services/ServiceProviderServices';
import jMoment from 'moment-jalaali';
import axios from 'axios';

const DialogServiceCall = ({ open, onClose, serviceSetId }) => {
  // for exporting
  const [filterParams, setFilterParams] = useState(null);
  const [loading, setLoading] = useState(false);
  const [size, setSize] = useState(10);
  const [page, setPage] = useState(0);
  const { downloadFile, isExporting } = useExportFile({
    url: `/report/serviceProvider/numberOfCalls/${serviceSetId}/export`,
    filename: 'service-providers-details-report',
  });
  const [bodyParams, setBodyParams] = useState({
    filterVOS: [],
    parentParams: [],
    orderByElementVOS: [],
  });

  const classes = useStyles();
  const getServiceSetProvider = async (query) => {
    setLoading(true);
    const filter = [];
    let orderBy = [];
    const parentParams = [];
    const params = {
      page: query ? query?.pageNumber : page,
      size: query ? query?.pageSize : size,

      startYearMonth: jMoment(new Date())
        .subtract('180', 'days')
        .locale('en')
        ?.format('jYYYY/jMM/jDD 00:00:00'),
      endYearMonth: jMoment(new Date()).locale('en')?.format('jYYYY/jMM/jDD 23:59:59'),
    };
    if (query?.filters.length) {
      query.filters.forEach((row) => {
        if (row.column.field === 'timeCalling') {
          filter.push({
            id: columnsId[row.column.field],
            value: row.value,
          });
        } else if (row.column.field === 'dateCalling') {
          filter.push(
            {
              id: columnsId[row.column.field][0],
              value: row.value.startDate,
            },
            {
              id: columnsId[row.column.field][1],
              value: row.value.endDate,
            },
          );
          params.startYearMonth = row.value.startDate;
          params.endYearMonth = row.value.endDate;
        } else {
          Array.isArray(columnsId[row.column.field])
            ? columnsId[row.column.field].forEach((id) => {
              filter.push({
                id,
                value: row.value,
              });
            })
            : filter.push({
              id: columnsId[row.column.field],
              value: row.value,
            });
        }
      });
    }

    if (query?.orderBy) {
      const desc = query.orderDirection === 'desc';
      orderBy = query?.orderBy.field
        ? query?.orderBy.title === 'تاریخ فراخوانی'
          ? [
            { name: 'از تاریخ فراخوانی', desc },
            { name: 'تا تاریخ فراخوانی', desc },
          ]
          : query?.orderBy.title === 'مبلغ فاکتور'
            ? [
              { name: 'از مبلغ فاکتور', desc },
              { name: 'تا مبلغ فاکتور', desc },
            ]
            : [{ name: query?.orderBy.title, desc }]
        : [];
    }

    const postBodyParams = {
      filterVOS: filter,
      parentParams,
      orderByElementVOS: orderBy,
    };
    setBodyParams(postBodyParams);
    setFilterParams({ data: postBodyParams, params });

    try {
      const res = await ServiceProviderServices.getServiceSetProviders(
        serviceSetId,
        postBodyParams,
        params,
      );
      const data = res.data.result.rows.map((row, key) => ({
        dateCalling: row.cols[0],
        timeCalling: row.cols[1],
        referenceId: row.cols[2],
        businessId: row.cols[3],
        businessName: row.cols[4],
        callerId: row.cols[5],
        invoiceId: row.cols[6],
        invoicePrice: row.cols[7],
        status: row.cols[8],
      }));
      setLoading(false);
      return {
        data,
        page: query ? query?.pageNumber : page,
        totalCount: res.data.result.totalCount,
      };
    } catch (error) {
      if (axios.isCancel(error)) {
        setLoading(true);
      } else {
        setLoading(false);
        return {
          data: [],
          page: query ? query?.pageNumber : page,
          totalCount: 0,
        };
      }
    }
  };

  const onExport = (type, index) => {
    const types = ['xls', 'csv'];
    if (!serviceSetId) return;
    downloadFile(types[index], filterParams?.data, filterParams?.params);
  };
  return (
    <Dialog
      onClose={onClose}
      aria-labelledby="simple-dialog-title"
      fullWidth
      maxWidth="lg"
      open={open}
      className={classes.dialogMain}
    >
      <DialogTitle className={classes.title} onClose={onClose}>
        جزییات سرویس
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
          size="large">
          <Icons icon='Close' color="#939393" size="20" />
        </IconButton>
      </DialogTitle>
      <DialogContent className={classes.dialog}>
        <Grid
          item
          container
          justifyContent="flex-end"
          alignItems="flex-end"
          style={{ marginBottom: 16 }}
          xs={12}
        >
          <Grid item>
            <ExportButton loading={isExporting} types={['xls', 'csv']} onExport={onExport} />
          </Grid>
        </Grid>

        <TableComponents
          data={getServiceSetProvider}
          columns={columns}
          isLoading={loading}
          onChange={(ps) => {
            setPage(ps?.pageNumber);
            setSize(ps?.pageSize);
            return getServiceSetProvider(ps);
          }}
        />
      </DialogContent>
    </Dialog>
  );
};

const useStyles = makeStyles((theme) => ({
  dialogMain: {
    '& .MuiDialog-paper': {
      borderRadius: '10px',
      overflowY: 'inherit',
    },
    '& .MuiDialogContent-root': {
      overflowY: 'auto',
      '&::scrollbar-track': {
        width: '0',
        minWidth: '0',
      },
      '&::-moz-scrollbar-track': {
        width: '0',
        minWidth: '0',
      },
      '&::-webkit-scrollbar-track': {
        width: '0',
        minWidth: '0',
      },
      '&::-webkit-scrollbar': {
        width: '0',
        minWidth: '0',
      },
      '&::-webkit-scrollbar-thumb': {
        width: '0',
        minWidth: '0',
      },
      '&.noneOverFlow': {
        overflowY: 'inherit',
      },
    },
    '& .MuiDialogActions-root': {
      justifyContent: 'flex-start',
      display: 'flex',
      flexDirection: 'row-reverse',
      padding: '20px',
      gap: '15px',
    },
    '& .MuiDialog-container': {
      width: '100vw',
      [theme.breakpoints.down('sm')]: {
        width: '100%',
      },
    },
  },
  title: {
    margin: 0,
    padding: '20px',
    borderBottom: '1px solid #E2E5E9',

    '& h2': {
      fontSize: 16,
      color: '#0C0E10',
    },
  },

  dialog: {
    textAlign: 'left',
    direction: 'ltr',
    padding: theme.spacing(2),
    lineHeight: 2,
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
}));

export default DialogServiceCall;
